import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import ButtonComponent from "../../../components/common/button/Button";
import DatePicker from "../../../components/common/DatePicker";
import './index.css';

const ModalContent = (props) => {
  const getDisabledDates = () => {
    const disabledDates = [];
    props?.rows.forEach((row) => {
      if (row.excludeFromDate && row.excludeToDate) {
        let currentDate = row.excludeFromDate;
        const endDate = row.excludeToDate;
        while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
          disabledDates.push(currentDate);
          currentDate = currentDate.add(1, 'day');
        }
      }
    });
    return disabledDates;
  };

  const shouldDisableDate = (date) => {
    const disabledDates = getDisabledDates();
    return disabledDates.some(
      (disabledDate) => date.isSame(disabledDate, 'day')
    );
  };

  return (
    <Grid
      sx={{
        "& .MuiInputBase-root": { height: "90%" },
      }}
    >
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead sx={{ background: "#f2f2f2" }}>
            <TableRow>
              <TableCell sx={{ width: "150px" }}>No. of Range</TableCell>
              <TableCell>From Date</TableCell>
              <TableCell>To Date</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.rows?.map((row, index) => {
              return (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  className="my-date"
                >
                  <TableCell
                    component="th"
                    scope="row"
                    name="range"
                    value={row?.range}
                  >
                    {row?.range}
                  </TableCell>
                  <TableCell
                    sx={{
                      "& .MuiFormControl-root": {
                        justifyContent: "center",
                      },
                    }}
                  >
                    <DatePicker
                      label="Select from Date"
                      name="excludeFromDate"
                      defaultValue={row?.excludeFromDate}
                      value={row?.excludeFromDate}
                      onChange={(e) =>
                        props?.handleExcludeDateChange(e, "excludeFromDate", index)
                      }
                      minDate={props?.minFromDate}
                      maxDate={row?.excludeToDate ? row?.excludeToDate : props?.maxToDate}
                      shouldDisableDate={shouldDisableDate}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      "& .MuiFormControl-root": {
                        justifyContent: "center",
                      },
                    }}
                  >
                    <DatePicker
                      label="Select to Date"
                      name="excludeToDate"
                      defaultValue={row?.excludeToDate}
                      value={row?.excludeToDate}
                      onChange={(e) =>
                        props?.handleExcludeDateChange(e, "excludeToDate", index)
                      }
                      minDate={row?.excludeFromDate ? row?.excludeFromDate : props?.minFromDate}
                      maxDate={props?.maxToDate}
                      shouldDisableDate={shouldDisableDate}
                    />
                  </TableCell>
                  <TableCell>
                    {props?.rows?.length > 1 && (
                      <DeleteIcon
                        name="del"
                        onClick={() => props?.delRowHandler(index)}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid
        mt={1}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          "& .MuiButtonBase-root": { border: "1px solid #000" },
        }}
      >
        <ButtonComponent
          label="Add"
          bgColor="#fff"
          color="#000"
          onClick={props?.handleAddRows}
          disabled={props?.excludeModalBtnDisabled}
        />
      </Grid>
    </Grid>
  );
};

const ModalFooter = (props) => {
  return (
    <Grid sx={{ display: "flex", gap: "16px" }}>
      <ButtonComponent
        maxWidth="170px"
        label="Clear All"
        bgColor="white"
        color="black"
        disabled={props.excludeModalBtnDisabled}
        onClick={props.clearAllExcludeModal}
      />
      <ButtonComponent
        maxWidth="170px"
        label="Submit"
        bgColor="black"
        color="white"
        onClick={props.submitExcludeModalHandler}
        disabled= {props.excludeModalBtnDisabled}
      />
    </Grid>
  );
};

export { ModalFooter, ModalContent };
